<template>
    <v-container>
        <v-form ref="from" v-model="validation" lazy-validation>
            <v-container>
                <v-flex xs12 md12>
                    <v-toolbar color="white" dark flat dense cad>
                        <v-toolbar-title class="indigo--text">Ingreso de Multas</v-toolbar-title>
                    </v-toolbar>
                </v-flex>
                <v-layout justify-center>
                    <v-flex xs12 md4>
                        <v-select v-model="idContratoValue" :items="idContratoSelect" label="Contrato"
                            item-text="nombre" item-value="code" v-on:change="changeRoute()"></v-select>
                    </v-flex>
                    <v-flex xs12 md4>
                        <v-text-field v-model="proveedorValue" label="Proveedor" :box="isDisabled"
                            :readonly="isDisabled"></v-text-field>
                    </v-flex>
                    <v-flex xs12 md4>
                        <v-text-field v-model="itemsValue" label="Items" :box="isDisabled"
                            :readonly="isDisabled"></v-text-field>
                    </v-flex>
                    <v-flex xs12 md4>
                        <v-text-field v-model="productoValue" label="Numeral"></v-text-field>
                    </v-flex>
                </v-layout>
                <v-card>
                    <v-container>
                        <v-layout>
                            <v-flex xs12 md6>
                                <v-text-field v-model="conceptoValue"
                                    label="Concepto por el que se le aplica la multa"></v-text-field>
                                <v-textarea name="input-7-1" v-model="observacionValue" label="Detalle de la multa"
                                    value maxlength="500"></v-textarea>
                            </v-flex>
                            <v-flex xs12 md1></v-flex>
                            <v-flex xs12 md6>
                                <v-menu v-model="menu1" :close-on-content-click="false" :nudge-right="40" lazy
                                    transition="scale-transition" offset-y full-width min-width="290px">
                                    <template v-slot:activator="{ on }">
                                        <v-text-field v-model="fechaValue" label="Fecha Multa" prepend-icon="event"
                                            v-on="on"></v-text-field>
                                    </template>
                                    <v-date-picker v-model="fechaValue" @input="menu1 = false" no-title locale="es"
                                        first-day-of-week="1"></v-date-picker>
                                </v-menu>
                                <v-text-field v-model="montoValue" label="Monto de multa $"></v-text-field>
                                <data-adjunto :documentoId="id" :tipeView="tipeView"
                                    :tipeArchive="tipeArchive"></data-adjunto>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card>
                <v-card-actions class="pb-3">
                    <v-btn color="primary" dark class="mb-2" @click="saveMulta()" :disabled="disabledSubmit">
                        Guardar
                        <v-icon right dark>save</v-icon>
                    </v-btn>
                </v-card-actions>
            </v-container>
        </v-form>
    </v-container>
</template>
<script>
import jwtDecode from "jwt-decode";
import axios from "axios";
import { misMixins } from "@/mixins/myMixing.js";
import { validationMixin } from "vuelidate";
import { required, maxLength, email } from "vuelidate/lib/validators";
import DataAdjunto from "@/components/AdjuntoData.vue";
export default {
    name: "pagos-sub-tab",

    components: {
        DataAdjunto,
    },
    props: {},
    mixins: [misMixins, validationMixin],
    data: () => ({
        usuarioLoggedTipe: "",
        userId: "",
        disabledSubmit: false,
        menu1: false,
        fechaSelect: [],
        fechaValue: null,
        text: "En construccion",
        contratoId: "",
        tabSelected: "",
        activeTab: "",
        index: "",
        active_tab: "",
        observacionValue: "",
        conceptoValue: "",
        montoValue: "",
        idContratoValue: "",
        idContratoSelect: [],
        itemsValue: "",
        productoValue: "",
        id: "",
        tipeArchive: "",
        proveedorValue: "",
        result: [],
    }),
    mounted() { },
    created() {
        this.tipeArchive = ".pdf,.doc,.jpg,.png";
        //   this.usuarioLoggedTipe = this.$store.getters.userLogged.tipo;
        //   this.tipeView = this.$route.params.tipeView;

        //   this.subPro = this.$store.getters.subProTabSelectedStored;
        //   this.tab = this.$store.getters.subTabSelectedStored;
        const token = localStorage.getItem("token");
        const decoded = jwtDecode(token);
        const user = decoded.dto;

        this.usuarioLoggedTipe = user.tipo;
        this.userId = user.id;

        this.loadData();
    },
    computed: {
        isDisabled() {
            return true;
        },
    },
    methods: {
        async changeRoute() {
            if (this.idContratoValue == "" || this.idContratoValue == null) {
                console.log("id vacio");
            } else {
                try {
                    // hacer un get contratos by id
                    const response = await axios.get(`/contrato/${this.idContratoValue}`);

                    //   const resp = await axios.post("/contratos/filter", body);
                    console.log("Detalle del contrato:", response.data);
                    if (response.data != null) {
                        const item = response.data;
                        this.proveedorValue = item.proveedor.razonSocial || "";
                        this.itemsValue = item.itemContrato || "";
                    }
                } catch (error) {
                    console.error("Error al cargar detalle del contrato:", error);
                }
            }
        },
        saveMulta() {
            this.disabledSubmit = true;
            let base64EncodedStr = this.base64Value;
            this.loading = true;
            this.body = {
                id: "",
                idContrato: this.idContratoValue,
                periodo: "",
                fechaMulta:
                    this.fechaValue && this.fechaValue != null
                        ? this.formatoFecha(this.fechaValue)
                        : null,
                productoReporte: this.productoValue,
                observacion: this.observacionValue,
                monto: this.montoValue,
                filename: this.filenameValue,
                documentoCV: base64EncodedStr,
            };
            axios
                .post("/pagosMultas/saveMulta", this.body)
                .then((response) => {
                    this.resp = response.data;
                    this.loading = false;
                    window.getApp.$emit("APP_SAVE");
                    this.volver();
                    this.disabledSubmit = false;
                })
                .catch((error) => {
                    if (error) {
                        console.log(error.response.data);
                        window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
                        this.loading = false;
                        this.disabledSubmit = false;
                    }
                });
        },
        async loadContratosByIdUsuario() {
            try {
                const body = { userId: this.userId };
                const response = await axios.post("/contratos/usuarios/filter", body);
                console.log("Contratos por loadContratosByIdUsuario:", response.data);
                this.idContratoSelect = response.data.map(p => ({
                    nombre: p.codigo,
                    code: p.id
                }));
            } catch (error) {
                console.error("Error al cargar contratos:", error);
            }
        },
        async loadProveedoresFilter() {
            this.body = {
                servicio: null,
                periodo: null,
                proveedor: null,
                estado: null,
                subProceso: "",
                idContrato: this.idContratoValue ? this.idContratoValue : null,
                proceso: null,
            };
            return await axios
                .post("/contratos/filter", this.body)
                .then(response => {
                    console.log("Contratos por loadProveedoresFilter:", response.data);
                    this.idContratoSelect = response.data.map(p => ({
                        nombre: p.codigo,
                        code: p.id
                    }));
                })
                .catch((error) => {
                    if (error) {
                        console.log(error.response.data);
                    }
                });
        }
        ,
        //   loadContratoSelect() {
        //     let id = [];
        //     this.itemsProveedor.forEach(function (p) {
        //       let index = id.findIndex((x) => x.id == p.id);
        //       if (index === -1) {
        //         id.push({ nombre: p.codigo, code: p.id });
        //       }
        //     });
        //     this.idContratoSelect = id;
        //   },
        loadProveedorSelect() {
            let prov = [];
            this.result.forEach(function (p) {
                let index = prov.findIndex(
                    (x) => x.razonSocial == p.proveedor.razonSocial
                );
                if (index === -1) {
                    prov.push(p.proveedor.razonSocial);
                }
            });
            this.proveedorValue = prov;
        },
        loadItemSelect() {
            let item = [];
            this.result.forEach(function (p) {
                let index = item.findIndex((x) => x.itemContrato == p.itemContrato);
                if (index === -1) {
                    item.push(p.itemContrato);
                }
            });
            this.itemsValue = item;
        },
        async loadData() {
            this.loading = true;
            this.loadProveedoresFilter();
            // this.loadContratoSelect();
        },
        volver() {
            this.idContratoValue = "";
            this.proveedorValue = "";
            this.itemsValue = "";
            this.productoValue = "";
            this.fechaValue = "";
            this.conceptoValue = "";
            this.montoValue = "";
            this.observacionValue = "";
        },
    },
};
</script>